export const faqs = [
  {
    question: "faqsSection.question1.question",
    answer: "faqsSection.question1.answer",
  },
  {
    question: "faqsSection.question2.question",
    answer: "faqsSection.question2.answer",
  },
  {
    question: "faqsSection.question3.question",
    answer: "faqsSection.question3.answer",
  },
  {
    question: "faqsSection.question5.question",
    answer: "faqsSection.question5.answer",
  },
  {
    question: "faqsSection.question6.question",
    answer: "faqsSection.question6.answer",
  },
];

export const migrationFaqs = [
  {
    question: "migrationFaqs.question1.question",
    answer: "migrationFaqs.question1.answer",
  },
  {
    question: "migrationFaqs.question2.question",
    answer: "migrationFaqs.question2.answer",
  },
  {
    question: "migrationFaqs.question3.question",
    answer: "migrationFaqs.question3.answer",
  },
  {
    question: "migrationFaqs.question5.question",
    answer: "migrationFaqs.question5.answer",
  },
  {
    question: "migrationFaqs.question6.question",
    answer: "migrationFaqs.question6.answer",
  },
];
